module.exports = "<div class=\"content-page\">\n  <div class=\"gradient\"></div>\n  <div class=\"video-container\">\n    <img [src]=\"video.thumbnailUrl\">\n    <iframe id=\"ytplayer\" [src]=\"video.embedUrl\" frameborder=\"0\" allowtransparency=\"true\" sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms allow-presentation\"></iframe>\n  </div>\n  <h1>{{video.title.replace(' | Fairy Lullaby', '')}}</h1>\n  <p>{{video.description}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/video-book-page/video-book-page.component.html
// module id = ./src/app/components/video-book-page/video-book-page.component.html
// module chunks = main